import React, { FunctionComponent } from "react";
import { FeedstockQualityPanelStyled, FeedstockQualityMainStyled, FeedstockQualityTitleStyled } from "./style";
import { Grid } from "@mui/material";

interface FeedstockQualityTitleProps {
  title: string;
}

const FeedstockQualityTitle = ({ title }: FeedstockQualityTitleProps) => {
  return (
    <FeedstockQualityTitleStyled variant="h1">
      {title}
    </FeedstockQualityTitleStyled>
  );
};

const FeedstockQualityBody: FunctionComponent = () => {
  return (
    <FeedstockQualityMainStyled>
      <Grid container>
        <Grid item md={12}>
          <FeedstockQualityTitle title="Feedstock Quality" />
        </Grid>
        <Grid item md={12}>
          <FeedstockQualityPanelStyled>
            {/* <iframe 
              title="Painel MP Trimetral vTBC - 19_02_2024"
              src="https://app.powerbi.com/reportEmbed?reportId=175aba6a-d5d6-4c4b-bcc4-15fbff58afc3&autoAuth=true&ctid=592b5396-bf52-4b35-a844-d5ab522c3666">
            </iframe> */}
            <iframe
              title="Painel MP Trimetral vTBC" 
              data-info="Updated at 05-10-2026"
              src="https://app.powerbi.com/reportEmbed?reportId=4c300819-8df7-416d-bf6c-55f571d4782e&autoAuth=true&ctid=592b5396-bf52-4b35-a844-d5ab522c3666"
              frameBorder="0"
              allowFullScreen>
            </iframe>
          </FeedstockQualityPanelStyled>
        </Grid>
      </Grid>
    </FeedstockQualityMainStyled>
  );
};

export default function FeedstockQualityPage() {
  return (
    <Grid container>
      <FeedstockQualityBody />
    </Grid>
  );  
}